<template>
  <div :class="!right? 'service-cell-container' : 'service-cell-container service-cell-end'">
    <div class="right-content"
         v-if="right">{{msg.payload.body.content}}</div>
    <img :src="!right?require('../../common/img/service-avatar.png'): require('../../common/img/service-client.png')" />
    <div class="left-content"
         v-if="!right">{{msg.payload.body.content}}</div>
  </div>
</template>

<script>
export default {
  props: {
    right: {
      type: Boolean,
      default: true
    },
    msg: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {

  }
}
</script>

<style scoped lang="less">
.service-cell-end {
  justify-content: flex-end;
}
.service-cell-container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 20px;
  img {
    width: 48px;
    height: 48px;
    border-radius: 6px;
  }
  .left-content {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    white-space: pre-wrap;
    background: #f3f3f3;
    padding: 14px 16px;
    margin-left: 10px;
    border-radius: 6px;
    position: relative;
    max-width: 260px;
    text-align: start;
    line-height: 20px;
  }
  .left-content::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 29px;
    margin-top: -10px;
    border: 5px solid transparent;
    border-right-color: #f3f3f3;
  }
  .right-content {
    font-size: 14px;
    font-weight: 400;
    white-space: pre-wrap;
    background: #ff4e5d;
    color: rgba(255, 255, 255, 1);
    padding: 14px 16px;
    margin-right: 10px;
    border-radius: 6px;
    position: relative;
    max-width: 260px;
    text-align: start;
    line-height: 20px;
  }
  .right-content::before {
    content: "";
    position: absolute;
    right: -10px;
    top: 29px;
    margin-top: -10px;
    border: 5px solid transparent;
    border-left-color: #ff4e5d;
  }
}
</style>
